function showNotice(message){
    if(message=="sureSave"){
      return "确认保存？"
    }else if(message=="submission"){
      return "确认提交？"
    }else if(message=="confirmedPass"){
      return "确认通过？"
    }else if(message=="confirmReturn"){
      return "确认返回？"
    }else if(message=="cancellation"){
      return "确认撤销？"
    }else if(message=="rejection"){
      return "确认驳回？"
    }else if(message=="deletion"){
      return "确认删除？"
    }else if(message=="confirmBack"){
      return "确认退回？"
    }else if(message=="confirmToSend"){
      return "是否确认发送？"
    }else if(message=="bulkSend"){
      return "是否确认批量发送？"
    }else if(message=="deletePicture"){
      return "确认删除选中图片？"
    }
}

export default {
  showNotice
}



// WEBPACK FOOTER //
// ./src/util/notice.js